import { render, staticRenderFns } from "./NationalPatentReceivingOffice.vue?vue&type=template&id=034d54fb&"
import script from "./NationalPatentReceivingOffice.vue?vue&type=script&lang=js&"
export * from "./NationalPatentReceivingOffice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports